<template>
    <div>
        <nav-header></nav-header>
        <div class="alterpswd-form validate-form p-l-50 p-r-50 p-t-10 p-b-150" >
            <section class="page-content">
                <div class="page-title">
                    <h2>Alterar Senha</h2>
                </div>
                <hr/><br>
                <div class="wrap-form-fields" style="align: center">
                    <div class="input-container">
                        <label class="label-input">Senha Atual</label>
                        <input width="10" type="password" v-model="currentPassword" id="inputCurrentPassword" class="input-field" size="16"/>
                    </div>
                    <br />
                    <div class="input-container">
                        <label class="label-input">Nova Senha</label>
                        <input type="password" v-model="newPassword" id="inputNewPassword" class="input-field" />
                    </div>
                    <password v-model="newPassword" :strength-meter-only="true" @score="setPasswordScore" />
                    <div class="input-container">
                        <label class="label-input">Confirmar Nova Senha</label>
                        <input type="password" v-model="reNewPassword" @paste.prevent id="inputReNewPassword" class="input-field" />
                    </div>
                    <br />
                </div>
                <button class="btn btn-secondary" v-on:click="$router.push({name:'home'})" style="aling: left; margin-left: 10px">Cancelar</button>
                <button class="btn btn-primary" v-on:click="this.alterPassword" style="aling: left">Confirmar</button>
            </section>
        </div>
        <user-profile-footer></user-profile-footer>
    </div>
</template>

<script>
    import axios from 'axios';
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue'
    import Password from 'vue-password-strength-meter';
    import config from '../helpers/generalConfig';

    export default {
        components: { 
            UserProfileFooter,
            NavHeader,
            Password 
        },
        data() {
            return {
                currentPassword:'',
                newPassword: '',
                reNewPassword: ''
            };
        },
        methods: {
            alterPassword() {
                if (!this.currentPassword && !this.newPassword && !this.reNewPassword) {
                    this.$bvToast.toast('Preencha todos os campos.', {
                        title: 'Senha inválida',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                if(!this.currentPassword){
                    this.$bvToast.toast('Preencha o campo de senha atual.', {
                        title: 'Senha inválida',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                if(!this.newPassword){
                    this.$bvToast.toast('Preencha o campo de nova senha.', {
                        title: 'Senha inválida',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                if(this.newPassword === this.currentPassword){
                    this.$bvToast.toast('A nova senha não pode ser igual à senha atual', {
                        title: 'Senha inválida',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                if(this.newPassword !== this.reNewPassword) {
                    this.$bvToast.toast('A nova senha e a confirmação divergem.', {
                        title: 'Senha inválida',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                if (!this.newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,}$/gi)) {
                    this.$bvToast.toast(
                    "A senha deve conter pelo menos 1 dígito numérico, 1 letra minúscula, 1 letra maiúscula e 1 caráter especial.", 
                    { title: "Senha inválida", variant: "danger", solid: true }
                    );
                    return;
                }
                axios
                    .put(`${config.jsonServer}/user/alterPassword`, {
                        id: this.$store.getters['auth/user'].Id,
                        password: this.currentPassword,
                        newPassword: this.newPassword
                    },
                    { headers: { Authorization: `Bearer ${this.$store.getters['auth/token'].token}` } })
                    .then(() => {
                        this.$root.$bvToast.toast('Senha alterada com sucesso.', {
                            title: 'Alteração realizada',
                            variant: 'success',
                            solid: true
                        });
                        this.$router.push('/home');
                    })
                    .catch((err) => {
                        if(err.response){
                            this.$bvToast.toast(err.response.data.message, {
                                title: 'Erro na alteração',
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
            },
            setPasswordScore(score) {
                this.passwordScore = score;
            },

        }
        
    }
</script>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
    .alter {
        width: 35% !important;
    }

    .Password {
        margin-left: 0 !important;
        padding: 0 0 0 10px !important;
    }
</style>
